import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { t } from 'ttag'
import styled, { css } from 'styled-components'

import { RecommendationIcon } from '@h2/components/icons'
import { SLB90T, SLB40T } from '@h2/components/colors'

import { InstitutionInfo } from './results/relevant/InstitutionInfo'
import { OccupationInfo } from './results/relevant/OccupationInfo'
import { MajorInfo } from './results/relevant/MajorInfo'

import { guessSearchResultType } from '../../actions/search'

const PromotionContainer = styled.div`
  display: flex;
  position: absolute;
  top: 2px;
  right: 15px;
  font-weight: bold;
  color: ${SLB40T};
`
const ResultContainer = styled.div`
  ${({ isPromoted }) =>
    isPromoted
      ? css`
          border-top: 30px solid ${SLB90T};
          border-top-right-radius: 7px;
          border-top-left-radius: 7px;
          margin-bottom: 3px;
        `
      : ''};
`
const outputRelevantInfoForResult = item => {
  switch (item.resultType) {
    case 'college':
      return <InstitutionInfo item={item} />
    case 'major':
      return <MajorInfo item={item} />
    case 'occupation':
      return <OccupationInfo item={item} />
    default:
      console.log('FOUND', item)

      return null
  }
}
const calculateUrl = itm => {
  if (itm.url) {
    return itm.url
  }

  switch (itm.resultType) {
    case 'occupation':
      return `/profile/${itm.id}`
    case 'college':
      return `/colleges/profile/${itm.id}`
    case 'major':
      return `/majors/detail/${itm.id}`
    case 'program':
      if (itm.resultSource === 'programs') {
        return `/programs/${itm.id}`
      }

      return `/profiles/program/${itm.id}`
    case 'company':
      return `/profiles/company/${itm.id}`
    case 'certification':
      return `/profiles/certification/${itm.id}`
    case 'joborders':
      return `/jobs/external/${itm.id}`
    case 'moc':
      return `/military/profile/${itm.id}`
    default:
      return '#'
  }
}
const SearchResponseItem = ({
  item,
  showCompareCheckbox,
  onSelectForComparison,
  selectedMap
}) => {
  // console.log(item)
  const typeBadge = () => {
    // console.log(item)
    const typeInfo = guessSearchResultType(item.resultType, item.resultTypeMeta)

    return (
      <div className={`type-badge ${typeInfo.className}`}>
        <i className={typeInfo.iconClassName}></i> {typeInfo.title}
      </div>
    )
  }
  const addComparisonLink = itm => {
    const onChangeFn = e => {
      onSelectForComparison(itm, e)
    }

    if (showCompareCheckbox) {
      /*
       * const checkedAttr = isSelectedForComparison ? { checked: true}: {}
       *  console.log("Map of selected comparison items", isSelectedForComparison, selectedMap, itm.id)
       */
      return (
        <div style={{ width: '30px', float: 'left', justifyContent: 'center' }}>
          <input
            type="checkbox"
            checked={selectedMap[itm.id]}
            onChange={onChangeFn}
            aria-labelledby={`link-${item.id}`}
          />
        </div>
      )
    }

    return null
  }
  const mainBoxStyles = showCompareCheckbox
    ? { width: 'calc(100% - 40px)', marginLeft: '40px' }
    : {}

  return (
    <ResultContainer
      isPromoted={item.isPromotedByFlag}
      className={`search-response-item ${item.className}`}
      style={{ height: 'calc(100% - 4px)' }}>
      {item.isPromotedByFlag && (
        <PromotionContainer>
          <RecommendationIcon size="small" />
          {t`Promoted`}
        </PromotionContainer>
      )}
      {addComparisonLink(item)}
      <div style={mainBoxStyles}>
        <div className="result-flags">
          {item.flags?.map(flag => (
            <div
              className={`expandable-button small ${flag.cssClassName}`}
              key={`sri--inner-${flag.flag}`}>
              <span className="icon"></span>
              <div>{flag.flag}</div>
            </div>
          ))}
        </div>

        <Link to={calculateUrl(item)} className="result-link" id={`link-${item.id}`}>
          {item.title || t`Untitled Result`}
          {item.className?.split(' ').includes('strong-match') ? ' *' : ''}
        </Link>
        <div className="system-badge-holder clearfix">
          <div className="type-badge-icon pull-left">{typeBadge()}</div>
          {item.systemFlags.map(flag => (
            <div
              className={`expandable-button x-small ${flag.styleClass}`}
              key={`btn-badge-${flag.label}`}>
              <span className="icon"></span>
              <div>{flag.label}</div>
            </div>
          ))}
        </div>
        <p
          className="result-body"
          dangerouslySetInnerHTML={{ __html: item.description }}>
        </p>

        {outputRelevantInfoForResult(item)}
      </div>
    </ResultContainer>
  )
}

SearchResponseItem.propTypes = {
  item: PropTypes.object,
  showCompareCheckbox: PropTypes.bool,
  onSelectForComparison: PropTypes.func,
  selectedMap: PropTypes.object
}

export default SearchResponseItem
